@if (showShell()) {
  <app-marketplace-shell>
    <router-outlet />
  </app-marketplace-shell>
} @else {
  <router-outlet />
}

<app-toast-host />
